import React from "react"

// context for appConrol object
export const AppContext = React.createContext(null)
